<template>
  <LegalDocView
    type="privacy"
    :title="$t('privacy.title', 'Datenschutzerklärung')"
    :empty-text="$t('privacy.empty', 'Die Datenschutzerklärung wurde noch nicht veröffentlicht.')"
  />
</template>

<script setup>
import LegalDocView from '~/components/Legal/LegalDocView.vue'

definePageMeta({
  title: 'Datenschutzerklärung'
})
</script>
